import { init } from "@sentry/nextjs";

init({
  dsn: process.env.sentryDsn,
  tracesSampleRate: 1.0,
  release: `cancount-${process.env.environment}@1.1.0`,
  environment: process.env.environment,
});
